import { NavLink, Outlet } from 'react-router-dom';
import { Icon } from '@iconify-icon/react';
import useAuth from '#lib/hooks/use-auth.jsx';

function NavLinkItem({ to, children, label, isFirst }) {
    return (
        <li
            className={`border-b border-r md:border-r-0 border-neutral-200 group bg-white hover:bg-primary-600 px-2 md:w-full`}
        >
            <NavLink
                to={to}
                className="block px-2 py-3 flex items-center text-neutral-700 group-hover:text-primary-100 h-full w-full"
            >
                <div className="flex items-center gap-2">
                    {children}
                    <span>{label}</span>
                </div>
            </NavLink>
        </li>
    );
}

export default function SettingsRoot() {
    const { meta } = useAuth();
    return (
        <main className="grid grid-cols-[auto_min-content] h-full">
            <div className="flex flex-col md:flex-row h-full pt-14 gap-x-4 gap-y-2">
                <ul className="w-full md:w-1/4 md:max-w-[300px] flex-shrink-0 flex justify-start md:flex-col md:justify-start list-none bg-neutral-50 md:border-r md:border-neutral-200 text-sm">
                    <NavLinkItem to="account" label={_t.sideboard.account()} isFirst={true}>
                        <Icon icon="line-md:person" width="1.2rem" height="1.2rem" className="mr-1" />
                    </NavLinkItem>
                    {meta?.data?.mainUser && (
                        <NavLinkItem to="billing" label={_t.sideboard.billing()}>
                            <Icon
                                icon="material-symbols:shopping-bag-outline"
                                width="1.2rem"
                                height="1.2rem"
                                className="mr-1"
                            />
                        </NavLinkItem>
                    )}
                    <NavLinkItem to="password" label={_t.sideboard.password()}>
                        <Icon
                            icon="material-symbols:key-outline-rounded"
                            width="1.2rem"
                            height="1.2rem"
                            className="mr-1"
                        />
                    </NavLinkItem>
                </ul>
                <div className="flex-start bg-white rounded w-full h-full px-2 lg:px-0">
                    <Outlet />
                </div>
            </div>
        </main>
    );
}
